// Polyfill for the `name` attribute on <details>: opening one closes the others
// sharing that name. Native in current browsers — this only runs where it isn't.
(() => {
  if ('name' in HTMLDetailsElement.prototype) return;

  document.addEventListener(
    'toggle',
    (event) => {
      const opened = event.target;
      if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;

      const group = opened.getAttribute('name');
      if (!group) return;

      document.querySelectorAll(`details[name="${group}"][open]`).forEach((details) => {
        if (details !== opened) details.open = false;
      });
    },
    true
  );
})();
